// src/pages/academy/components/AcademyDeleteModal.jsx
import { Trash2, Loader2 } from "lucide-react";

export default function AcademyDeleteModal({
  title,
  itemName,
  warning,
  deleting,
  error,
  onCancel,
  onConfirm,
}) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-xl">
        <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-4 mx-auto">
          <Trash2 className="w-6 h-6 text-red-600" />
        </div>
        <h3 className="text-lg font-bold text-center text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-gray-500 text-center text-sm mb-2">
          Are you sure you want to delete{" "}
          <span className="font-semibold text-gray-700">"{itemName}"</span>?
        </p>
        {warning && (
          <p className="text-amber-700 bg-amber-50 border border-amber-200 rounded-lg text-xs text-center px-3 py-2 mb-2">
            {warning}
          </p>
        )}
        {error && (
          <p className="text-red-700 bg-red-50 border border-red-200 rounded-lg text-xs text-center px-3 py-2 mb-2">
            {error}
          </p>
        )}
        <div className="flex gap-3 mt-4">
          <button
            onClick={onCancel}
            disabled={deleting}
            className="flex-1 py-2.5 border border-gray-200 rounded-xl text-gray-700 hover:bg-gray-50 font-medium disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="flex-1 py-2.5 bg-red-600 text-white rounded-xl hover:bg-red-700 font-medium flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {deleting && <Loader2 className="w-4 h-4 animate-spin" />}
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}